module.exports = __webpack_public_path__ + "media/images/online/online-og-image-ed2c275116cd278d3f46faf4050fc8da.png";